import React from 'react';
import { Link } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';

export default function GuestCredits() {
  const { currentUser } = useAuth();
  const credits = currentUser?.guestCredits || 0;

  return (
    <div>
      <h2 style={s.pageTitle}>Guest Post Credits</h2>
      <div style={s.balanceCard}>
        <div style={s.balanceIcon}>🎟</div>
        <div>
          <div style={s.balanceValue}>{credits}</div>
          <div style={s.balanceLabel}>Available Guest Posting Credits</div>
        </div>
      </div>
      <div style={s.info}>
        <h3 style={s.infoTitle}>How it works</h3>
        <ul style={s.infoList}>
          <li>Each guest post submission uses 1 credit.</li>
          <li>Credits are added when you purchase a Guest Post package.</li>
          <li>Credits can be used across any of our partner publishing sites.</li>
        </ul>
        <Link to="/dashboard/packages/guest" style={s.buyBtn}>Buy More Credits →</Link>
      </div>
    </div>
  );
}

const s = {
  pageTitle: { margin: '0 0 1.5rem', fontSize: '1.4rem', fontWeight: 700, color: '#1a1a2e' },
  balanceCard: { background: '#fff', borderRadius: 10, padding: '2rem', boxShadow: '0 2px 12px rgba(0,0,0,0.07)', display: 'flex', alignItems: 'center', gap: '1.5rem', marginBottom: '1.5rem', borderLeft: '5px solid #1565c0' },
  balanceIcon: { fontSize: '3rem' },
  balanceValue: { fontSize: '3rem', fontWeight: 700, color: '#1565c0', lineHeight: 1 },
  balanceLabel: { color: '#666', fontSize: '0.9rem', marginTop: '0.25rem' },
  info: { background: '#fff', borderRadius: 10, padding: '1.5rem', boxShadow: '0 2px 12px rgba(0,0,0,0.07)' },
  infoTitle: { margin: '0 0 0.75rem', fontSize: '1rem', fontWeight: 700, color: '#1a1a2e' },
  infoList: { margin: '0 0 1.25rem', paddingLeft: '1.25rem', color: '#555', lineHeight: 2 },
  buyBtn: { display: 'inline-block', padding: '0.65rem 1.4rem', background: '#1565c0', color: '#fff', borderRadius: 6, textDecoration: 'none', fontWeight: 600, fontSize: '0.9rem' },
};
